import { AiAnno } from '@vueron/kiska';
import { withTranslation } from 'react-i18next';

import { DataDriven, Scalable } from '@/asset/icon';
import type { User, UserRole } from '@/type';

export const KEYS = {
  STORAGE_USER: 'STORAGE_USER',
  STORAGE_SIGNUP_EMAIL: 'STORAGE_SIGNUP_EMAIL',
  STORAGE_ACCESS_TOKEN: 'STORAGE_ACCESS_TOKEN',
  STORAGE_REFRESH_TOKEN: 'STORAGE_REFRESH_TOKEN',
  STORAGE_ID_TOKEN: 'STORAGE_ID_TOKEN',
  STORAGE_STORAGE_AUTH_URL: 'STORAGE_STORAGE_AUTH_URL',
  STORAGE_STORAGE_ACCESSIBLE_BUCKET_LIST:
    'STORAGE_STORAGE_ACCESSIBLE_BUCKET_LIST',
  STORAGE_STORAGE_ACCESS_KEY_ID: 'STORAGE_STORAGE_ACCESS_KEY_ID',
  STORAGE_STORAGE_SECRET_ACCESS_KEY: 'STORAGE_STORAGE_SECRET_ACCESS_KEY',
  STORAGE_STORAGE_SESSION_TOKEN: 'STORAGE_STORAGE_SESSION_TOKEN',
} as const;

export const INIT_USER: User = {
  id: '-1',
  email: '',
  role: '' as UserRole,
  profileImg: '',
  createdAt: '',
  deletedAt: -1,
  sub: '',
  updatedAt: '',
  name: '',
  recentCompleted: 0,
};

export const SIGN_IN_PANEL_LIST = [
  {
    Description: withTranslation()(({ t }) =>
      t('auth.signInAiAssistWorkflow.marver'),
    ),
    Icon: AiAnno,
    Title: withTranslation()(({ t }) => t('auth.signInPanel.aiWorkflow')),
    key: 'aiWorkflow',
  },
  {
    Description: withTranslation()(({ t }) =>
      t('auth.signInDataDriven.redesertion'),
    ),
    Icon: DataDriven,
    Title: withTranslation()(({ t }) => t('auth.signInPanel.dataInsight')),
    key: 'dataInsight',
  },
  {
    Description: withTranslation()(({ t }) =>
      t('auth.signInScalable.reconciliation'),
    ),
    Icon: Scalable,
    Title: withTranslation()(({ t }) => t('auth.signInPanel.operations')),
    key: 'operations',
  },
];
